// Vendors
import { useEffect } from 'react';
// Contexts
import { useAppContextConsumerHook } from 'contexts/app.context';
import { useFetchErrorContextConsumerHook } from 'contexts/fetch-error.context';
import { useProofIncomeContextConsumerHook } from '../contexts/proof-income.context';
// Types
import { ProofIncomeHookType } from './types/proof-income.hook.type';
// Enums
import { ProofIncomeStatesEnumeration } from '../enumerations/proof-income-states.enumeration';
// Handlers
import { ProofIncomeHandlers } from '../handlers/proof-income.handlers';

const useProofIncomeHook = (): ProofIncomeHookType => {
  const { fetching: externalFetching, error } = useFetchErrorContextConsumerHook(),
    { proofIncomeState, setProofIncomeState } = useProofIncomeContextConsumerHook(),
    { setOnBackHeader, 
      setStatesVisited, 
      statesVisited, 
      onBackHeader, 
      onBackClickHeader, 
      setOnBackClickHeader 
    } = useAppContextConsumerHook();
    
  const { handleOnBackHeader } = ProofIncomeHandlers({
    initialState: ProofIncomeStatesEnumeration.LANDING,
    enumStates: ProofIncomeStatesEnumeration,
    setState: setProofIncomeState as any,
    state: proofIncomeState,
    onBackClickHeader,
    onBackHeader,
    statesVisited,
    setOnBackHeader,
    setOnBackClickHeader,
    setStatesVisited,
  });

  useEffect(() => {
    handleOnBackHeader();
  }, [proofIncomeState, onBackClickHeader]);

  return {
    error,
    externalFetching,
    proofIncomeState,
  };
};

export { useProofIncomeHook };
